import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ typography }) => ({
  container: {
    height: '100%',
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    overflow: 'hidden'
  },
  icon: {
    fontSize: typography.h4.fontSize
  }
}));